export default "__VITE_ASSET__DPny27Md__"